/**
 * WatchEverything – SVG icon.
 */
import Colors from '@shared/assets/style/default/color';
import Props from '@shared/types/props/pressable';
import Screen from '@screen';

/** Watch all / full content list. */
export default function WatchEverythingIcon({ focused, height, width }: Props) {
  return (
    <svg
      xmlns='http://www.w3.org/2000/svg'
      height={`${height || 32 * Screen.widthRatio}`}
      width={`${width || 30 * Screen.widthRatio}`}
      viewBox={'0 0 47 50'}
    >
      <path
        d='M7.29234 50C4.8912 50 3.07553 49.3969 1.84532 48.1906C0.615106 46.9844 0 45.1971 0 42.8288V20.1456C0 17.7773 0.615106 15.99 1.84532 14.7838C3.07553 13.5775 4.8912 12.9744 7.29234 12.9744H39.6854C42.0866 12.9744 43.9022 13.5849 45.1325 14.8058C46.3775 16.0121 47 17.792 47 20.1456V42.8288C47 45.1824 46.3775 46.9623 45.1325 48.1686C43.9022 49.3895 42.0866 50 39.6854 50H7.29234ZM7.55913 45.6752H39.4186C40.4413 45.6752 41.2269 45.4031 41.7753 44.8588C42.3385 44.3292 42.6202 43.5275 42.6202 42.4537V20.5207C42.6202 19.4469 42.3385 18.6452 41.7753 18.1156C41.2269 17.5713 40.4413 17.2992 39.4186 17.2992H7.55913C6.5216 17.2992 5.72863 17.5713 5.18023 18.1156C4.64664 18.6452 4.37985 19.4469 4.37985 20.5207V42.4537C4.37985 43.5275 4.64664 44.3292 5.18023 44.8588C5.72863 45.4031 6.5216 45.6752 7.55913 45.6752ZM4.8912 9.37776C5.05424 8.33333 5.41738 7.52427 5.98061 6.95057C6.55866 6.37688 7.44056 6.09003 8.6263 6.09003H38.3737C39.5594 6.09003 40.4339 6.37688 40.9972 6.95057C41.5752 7.52427 41.9458 8.33333 42.1088 9.37776H4.8912ZM9.42668 3.00088C9.48597 2.0153 9.80464 1.27243 10.3827 0.772286C10.9756 0.257429 11.8056 0 12.8728 0H34.1272C35.1944 0 36.017 0.257429 36.5951 0.772286C37.1731 1.27243 37.5066 2.0153 37.5956 3.00088H9.42668Z'
        fill={focused ? Colors['dark'] : Colors['light']}
      />
    </svg>
  );
}
